import { fetchCategories } from '../../../../actions';
import { processCategories } from '../../../../services';

/**
 * API'den kategorileri getir ve işle
 * 
 * @param {Object} state - Uygulama state
 * @param {Object} services - Servisler
 * @returns {Function} - Kategorileri yükleme fonksiyonu
 */
export const createLoadCategoriesMethod = (state, services) => {
  const {
    categoryOptions,
    isLoadingCategories,
  } = state;

  const {
    assetStore,
    axios,
    settings,
    responseHandlerService,
  } = services;

  /**
   * API'den kategorileri getir
   */
  return async () => {
    isLoadingCategories.value = true;

    try {
      // API'den hiyerarşik kategorileri al
      const rawCategories = await fetchCategories({
        axios,
        settings,
        assetId: assetStore.assetId,
      });

      // Servis ile kategorileri işle
      categoryOptions.value = processCategories(rawCategories);
    } catch (error) {
      responseHandlerService.handleError(error, 'Kategoriler yüklenirken bir hata oluştu');
    } finally {
      isLoadingCategories.value = false;
    }
  };
};